import { type OptionValue, type Option } from "../../../types/option";
import { type OptionFieldsConfig } from "../../SelectBase";
import { getValueKey } from "../../SelectBase/helpers/getValueKey";

function isSelected<TValue extends Option>(
  opt: TValue,
  selected: OptionValue<TValue>[] | undefined,
  fieldConfig: OptionFieldsConfig<TValue>,
): boolean {
  if (!selected) {
    return false;
  }
  return selected.some((x) => getValueKey(opt, fieldConfig) === getValueKey(x, fieldConfig));
}

export { isSelected };
